module.exports = __webpack_public_path__ + "img/google.4f711cde.svg";